import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=56fa76a9&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"
import style0 from "./Training.vue?vue&type=style&index=0&id=56fa76a9&prod&lang=scss"
import style1 from "./Training.vue?vue&type=style&index=1&id=56fa76a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa76a9",
  null
  
)

export default component.exports